export const commonCenterStyle = {
    width: "100%",
    height: "100%",
    padding: "100px",
    display: "flex",
    alignItems: "center"
}